export var DEFAULT_NOTIFICATION_OPTIONS = {
  allowDuplicates: false,
  autoRemove: false,
  autoRemoveInterval: 3000
};